//
// # UI Mode Handler Base Class
//

import { type DrawTo } from "DrawCore/src/draw";

// # Handler Base Class
export abstract class ModeHandler {
  // True for modes that move entity geometry live, previewing the result before
  // committing it. Derived data that is only recomputed at commit time — junction
  // dots, SRV violation arrows — is stale for the whole duration of such a mode
  // and is hidden rather than drawn in its pre-move position. Note this is not
  // the same as "the mouse is down": a `G`-key grab and an endpoint stretch both
  // move geometry with no button held, and have the identical problem.
  movesGeometryLive: boolean = false;

  // Optional draw method for mode-specific overlays (box-select rect, rulers, etc.)
  draw?: (to: DrawTo) => void;
  // Abort the in-progress operation and return to the `Idle` mode.
  // The result of calling `abort` should be that the UI looks identical
  // to its state as of the moment before the mode was entered.
  abort = (): unknown => null;

  // Event handlers.
  // Note these are default-implemented to do nothing. Sub-classes override as needed.
  handleKey = (_: KeyboardEvent): unknown => null;
  handleMouseDown = (_: MouseEvent): unknown => null;
  handleMouseUp = (): unknown => null;
  handleDoubleClick = (): unknown => null;
  handleMouseMove = (): unknown => null;
}
